import { Form, Col, Row } from "react-bootstrap";
import PropsType from "prop-types";

const CustomSwitch = (props) => {
  const { label, name, onChange, value, labelSize = 2, inputSize = 10 } = props;

  return (
    <Form.Group as={Row} className="align-items-center justify-content-center">
      <Form.Label column sm={labelSize} className="text-center">
        {label}
      </Form.Label>
      <Col sm={inputSize}>
        <Form.Switch name={name} onChange={onChange} checked={value} />
      </Col>
    </Form.Group>
  );
};

CustomSwitch.propsTypes = {
  onChange: PropsType.func.isRequired,
  type: PropsType.string.isRequired,
  name: PropsType.string.isRequired,
};

export default CustomSwitch;
